'use es6';

import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
TargetPlaceholder.propTypes = {
  renderPlaceholder: PropTypes.func.isRequired,
  target: PropTypes.instanceOf(Element).isRequired,
  rootRelative: PropTypes.bool
};
TargetPlaceholder.defaultProps = {
  rootRelative: false
};
function rootRelativeOffset(el) {
  const rect = el.getBoundingClientRect();
  const {
    height,
    width
  } = rect;
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return {
    top: rect.top + scrollTop,
    left: rect.left + scrollLeft,
    height,
    width
  };
}
function offset(el) {
  return {
    top: el.offsetTop,
    left: el.offsetLeft,
    height: el.clientHeight,
    width: el.clientWidth
  };
}
const useAnimationFrame = callback => {
  const requestRef = useRef();
  const previousTimeRef = useRef();
  const animate = time => {
    if (previousTimeRef.current !== undefined) {
      const deltaTime = time - previousTimeRef.current;
      callback(deltaTime);
    }
    previousTimeRef.current = time;
    requestRef.current = requestAnimationFrame(animate);
  };
  useEffect(() => {
    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
  }, []); // eslint-disable-line
};
export default function TargetPlaceholder({
  target,
  renderPlaceholder,
  rootRelative
}) {
  const [placeholderHeight, setPlaceholderHeight] = useState(0);
  const [placeholderWidth, setPlaceholderWidth] = useState(0);
  const [placeholderTop, setPlaceholderTop] = useState(0);
  const [placeholderLeft, setPlaceholderLeft] = useState(0);
  useAnimationFrame(() => {
    const {
      height,
      width,
      top,
      left
    } = rootRelative ? rootRelativeOffset(target) : offset(target);
    setPlaceholderHeight(height);
    setPlaceholderWidth(width);
    setPlaceholderTop(top);
    setPlaceholderLeft(left);
  });
  if (!target || !renderPlaceholder) {
    return null;
  }
  const styles = {
    top: placeholderTop,
    left: placeholderLeft,
    width: placeholderWidth,
    height: placeholderHeight,
    position: 'absolute',
    display: 'flex',
    alignItems: 'stretch'
  };
  return /*#__PURE__*/_jsx("div", {
    style: styles,
    children: renderPlaceholder()
  });
}